module.exports = __webpack_public_path__ + "static/media/3.3be02ca2.jpg";